<ng-template #content>
  <div class="container flex column justify-center align-items-center">
    <div>
      <div class="container flex justify-center align-items-center">
        <div>
          <span class="capitalize">{{ 'copyright' | translate }}</span>&nbsp;<a
            href="https://www.utisha.com"
            >Utisha</a
          >
          2021-{{ thisYear }}&nbsp;
        </div>
        @if (!versionInfoVisible) {
          <ut-icon name="info" (click)="toggleVersionInfo()"></ut-icon>
        }
      </div>
    </div>
    @if (versionInfoVisible) {
      <div (click)="toggleVersionInfo()">
        Frontend {{ frontend }} - Backend {{ backend }} - &nbsp;
      </div>
    }
  </div>
</ng-template>
<app-responsive-container [template]="content"></app-responsive-container>
